import ArrowIcon from "./arrow-icon";
import UsersMenuIcon from "./users-icon";
import TeamsMenuIcon from "./teams-icon";
import SuppliersMenuIcon from "./supplier-icon";
import StandsMenuIcon from "./stands-icon";
import SettingsMenuIcon from "./settings-icon";
import LogoutMenuIcon from "./logout-icon";
import FlooringMenuIcon from "./flooring-icon";
import ExhibitionsMenuIcon from "./exhibitions-icon";
import EquipmentMenuIcon from "./equipment-icon";
import OrganizersMenuIcon from "./organizers-icon";
import PermissionsMenuIcon from "./permissions-icon";

import DotsIcon from "./dots-icon";
import CheckIcon from "./check-icon";
import CloseIcon from "./close-icon";
import DeleteIcon from "./delete-icon";
import DocumentIcon from "./document-icon";
import GridIcon from "./grid-icon";
import ImageIcon from "./image-icon";
import InformationIcon from "./information-icon";
import NoteIcon from "./note-icon";
import PlusIcon from "./plus-icon";
import SearchIcon from "./search-icon";
import TableIcon from "./table-icon";
import UploadIcon from "./upload-icon";
import ZoomIcon from "./zoom-icon";

import NotificationsIcon from "./notifications-icon";
import EventsIcon from "./events-icon";
import LastMinIcon from "./last-min-icon";
import ProfileIcon from "./profile-icon";
import SubContractorsIcon from "./subcontractors-icon";
import EditIcon from "./edit-icon";
import LogsIcon from "./logs-icon";
import SendPassIcon from "./send-pass-icon";
import ChangePassIcon from "./change-pass-icon";
import FilterIcon from "./filter-icon";
import DownloadIcon from "./download-icon";
import ImportIcon from "./import-icon";
import UpdateIcon from "./update-icon";
import KeyIcon from "./key-icon";
import AttentionIcon from "./attention-icon";
import GearIcon from "./gear-icon";
import InProcesIcon from "./in-proces-icon";
import NoJobsIcon from "./no-jobs-icon";
import PadlockIcon from "./padlock-icon";
import DocumentsIcon from "./documents-icon";
import BookmarkIcon from "./bookmark-icon";
import Cube3dIcon from "./cube3d-icon";
import ModelIcon from "./3d-icon";




const Icons = {
    Menu: {
        Users: UsersMenuIcon,
        Organizers: OrganizersMenuIcon,
        Teams: TeamsMenuIcon,
        Suppliers: SuppliersMenuIcon,
        Stands: StandsMenuIcon,
        Settings: SettingsMenuIcon,
        Logout: LogoutMenuIcon,
        Flooring: FlooringMenuIcon,
        Exhibitions: ExhibitionsMenuIcon,
        Equipment: EquipmentMenuIcon,
        Permissions: PermissionsMenuIcon,
    },

    Zoom: ZoomIcon,
    Upload: UploadIcon,
    Table: TableIcon,
    Search: SearchIcon,
    Plus: PlusIcon,
    Note: NoteIcon,
    Information: InformationIcon,
    Image: ImageIcon,
    Grid: GridIcon,
    Document: DocumentIcon,
    Close: CloseIcon,
    Check: CheckIcon,
    Dots: DotsIcon,
    Notifications: NotificationsIcon,
    Arrow: ArrowIcon,
    Events: EventsIcon,
    LastMin: LastMinIcon,
    Profile: ProfileIcon,
    SubContractors: SubContractorsIcon,
    Edit: EditIcon,
    Logs: LogsIcon,
    SendPass: SendPassIcon,
    Delete: DeleteIcon,
    ChangePass: ChangePassIcon,
    Filter: FilterIcon,
    Download: DownloadIcon,
    Import: ImportIcon,
    Update: UpdateIcon,
    Key: KeyIcon,
    Attention: AttentionIcon,
    Gear: GearIcon,
    InProces: InProcesIcon,
    NoJobs: NoJobsIcon,
    Padlock: PadlockIcon,
    Documents: DocumentsIcon,
    Bookmark: BookmarkIcon,
    Cube3d: Cube3dIcon,
    Model: ModelIcon
};

export default Icons;